module.exports = __webpack_public_path__ + "img/154.50ad744f.jpg";